module.exports = __webpack_public_path__ + "media/images/riders/small/ALESSANDRA_KELLER-a823786791edd9d3970d2fc1d81e2494.png";